(() => {
  if(window.wftHelpBound)return;window.wftHelpBound=true;
  let opener,previousOverflow;
  document.addEventListener('click',event=>{
    const trigger=event.target.closest('[data-help-open]');
    if(trigger){
      const dialog=document.getElementById(trigger.getAttribute('aria-controls'));if(!dialog)return;
      event.preventDefault();if(dialog.open)return;
      document.dispatchEvent(new Event('wft:close-quick-add'));
      opener=trigger;previousOverflow=document.documentElement.style.overflow;
      dialog.showModal();document.documentElement.style.overflow='hidden';trigger.setAttribute('aria-expanded','true');
      dialog.addEventListener('close',()=>{document.documentElement.style.overflow=previousOverflow;opener.setAttribute('aria-expanded','false');if(opener.isConnected)opener.focus({preventScroll:true});},{once:true});
      dialog.querySelector('[data-help-close]').focus();return;
    }
    if(event.target.closest('[data-help-close]'))event.target.closest('dialog').close();
    if(event.target.matches('.wft-help-drawer')){const r=event.target.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)event.target.close();}
  });
  document.addEventListener('shopify:section:unload',event=>{const dialog=event.target.querySelector('.wft-help-drawer[open]');if(dialog)dialog.close();});
})();
